import {Route, Routes} from 'react-router-dom'
import InterviewPage from './components/InterviewPage'
import InterviewFormBuilder from './components/InterviewFormBuilder'
import InterviewQuestionaire from './components/InterviewQuestionaire'
import InterviewEditForm from './components/InterviewEditForm'
import InterviewList from './components/InterviewList'
import InterviewSlidesQuestionaire from './components/InterviewSlidesQuestionaire'

function Interview() {
  return (
    <Routes>
      <Route path='/' element={<InterviewList />} />
      <Route path='/:projectid' element={<InterviewPage />} />
      <Route path='/create-interview' element={<InterviewFormBuilder />} />
      <Route path='/questionnaire/default/:id' element={<InterviewQuestionaire />} />
      <Route path='/questionnaire/slide/:id' element={<InterviewSlidesQuestionaire />} />
      <Route path='edit-interview/:id' element={<InterviewEditForm />} />
    </Routes>
  )
}

export default Interview
